import React, { useState, useEffect } from "react";
import { Col, Row, Card, CardBody, CardHeader } from "reactstrap";
import india_state from "./india_states.json";
import {
  useGetTradeInfoQuery,
  useGetSuppliersInfoQuery,
  useGetSuppliersIdInfoQuery,
  usePostSummaryDahboardMutation,
  usePostReportMutation,
} from "features/Procurement/common/ProcurementApiSlice";
import ProductionQuantityLimitsIcon from "@mui/icons-material/ProductionQuantityLimits";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Tooltip from "@mui/material/Tooltip";
import { Button, Modal, Table, Spinner } from "react-bootstrap";
import { selectCurrentRoles } from "features/auth/authSlice";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css"; // Ensure you import the CSS for proper styling
import TradesChart from "features/Procurement/common/adminDashProcChart";
import AdminMonthChart from "features/Procurement/common/AdminMonthChart";
import TopTenChart from "./TopTenChart";
import CustomSearchBar from "components/CustomSearchBar";
import NoData from "features/MobileProcurement/NoData";
import { store } from "app/store";
import { API_URL } from "app/config";
import swal from "sweetalert";

const SampleDashboard = () => {
  const [geojsonData, setGeojsonData] = useState(india_state);
  const RolesFromToken = useSelector(selectCurrentRoles);

  // const [users, setUsers] = useState([]);
  const [searchKey, setSearchKey] = useState("");
  const [location, setLocation] = useState([]);
  const [showLoading, setShowLoading] = useState(true);
  const [supplier_id, setSupplier_id] = useState([]);

  const [postSummary] = usePostSummaryDahboardMutation();
  const [postReport] = usePostReportMutation();
  const [loadingone, setShowLoadingOne] = useState(false);
  const [loadingtwo, setShowLoadingTwo] = useState(false);

  let supplierName = "";
  if (
    RolesFromToken?.groups?.includes("PROCUREMENT_MANAGER") ||
    RolesFromToken?.groups?.includes("PROCUREMENT_ADMIN") ||
    RolesFromToken?.realm_access?.roles.includes("admin")
  ) {
    supplierName = "";
  } else {
    supplierName = RolesFromToken?.organization_id;
  }

  // const { data: apiData } = useGetSampleDataDashboardQuery(locationName);
  const { data: tradeInfo } = useGetTradeInfoQuery(supplierName);
  // console.log("RolesFromToken",RolesFromToken)
  const { data: SupplierData, refetch } = useGetSuppliersInfoQuery(
    supplierName
  );

  const {
    data: SupplierIdData,
    refetch: refetchById,
  } = useGetSuppliersIdInfoQuery(
    { supplier_id, searchKey },
    { skip: !supplier_id, refetchOnMountOrArgChange: true }
  );
  const [supplierIdData, setSupplierIdData] = useState([]);
  const [Tradesdata, setTradesData] = useState([]);
  const [supplierList, setSupplierData] = useState([]);
  const [products, setProducts] = useState([]);
  const [viewAll, setViewAll] = useState(false);
  const [FinalCropName, setFinalCropName] = useState([]);
  const [FinalCropValue, setFinalCropValue] = useState([]);
  const [showcolouredBorder, setshowcolouredBorder] = useState(true);
  const [show, setShow] = useState(false);

  const [showDetails, setShowDetails] = useState(false);
  const [topTraders, setTopTraders] = useState([]);
  const [showIdLoading, setshowIdLoading] = useState(false);
  const [loaderIndex, setLoaderIndex] = useState("");
  const handleClose = () => {
    setShow(false);
    setshowIdLoading(false);
  };
  const handleCloseDetails = () => setShowDetails(false);
  const [ListName, setListName] = useState("");
  useEffect(() => {
    setTradesData(tradeInfo?.data);

    if (SupplierData != undefined) {
      setSupplierData(SupplierData?.data);
      console.log("SupplierData?.data", SupplierData?.data);
      const topTrades = [...(SupplierData?.data || [])] // Create a shallow copy
        .sort((a, b) => b.total_trades - a.total_trades) // Sort the copy
        .slice(0, 10); // Take the top 10 entries

      setTopTraders(topTrades);
      setShowLoading(false);
    }
  }, [tradeInfo, SupplierData]);

  useEffect(() => {
    let location = [];
    let products = [];

    // setLocation(analyticsdata?.locations);

    const states = supplierList?.map((item) => item.state);
    const uniqueStatesArray = Array.from(new Set(states));
    setLocation(uniqueStatesArray);

    // setUniqueStates(uniqueStatesArray);

    supplierList?.map((item) => {
      const itemObj = {
        value: item.total_qty,
        name: item.supplier_name,
        price: item.total_price,
      };
      products.push(itemObj);
    });
    setProducts(products);
  }, [supplierList]);
  useEffect(() => {
    if (SupplierIdData !== undefined) {
      setSupplierIdData(SupplierIdData?.data);
      setshowIdLoading(false);
    }
  }, [SupplierIdData]);

  useEffect(() => {
    var FinalCropName = [];
    var FinalCropValue = [];
    const sortedData = products.sort((a, b) => b.price - a.price);
    // console.log("sortedData",sortedData)
    sortedData?.slice(0, 10)?.map((item, index) => {
      FinalCropName.push(item.name);
      FinalCropValue.push(item.price);
    });
    setFinalCropName(FinalCropName);
    setFinalCropValue(FinalCropValue);
  }, [products]);

  const handleDynamicClass = (index) => {
    let className = "";
    switch (index % 3) {
      case 0:
        className = " bg-c-greenSample f300 ";
        break;
      case 1:
        className = "bg-c-blueSample f300 ";
        break;
      case 2:
        className = "bg-c-yellowSample f300  ";
        break;
      default:
        break;
    }
    return className;
  };
  const handleDynamicClassText = (index) => {
    let className = "";
    switch (index % 3) {
      case 0:
        className = " bg-c-green-textColor cursor-pointer f300  ";
        break;
      case 1:
        className = " bg-c-blue-textColor cursor-pointer f300 ";
        break;
      case 2:
        className = "bg-c-yellow-textColor cursor-pointer f300 ";
        break;
      default:
        break;
    }
    return className;
  };

  const handleIdData = (id, index) => {
    setSupplier_id(id);
    setshowcolouredBorder(index);
    setShow(true);
    setSupplierIdData([]);
    setshowIdLoading(true);
  };
  const handleDetails = (listName) => {
    setShowDetails(true);
    setListName(listName);
  };
  const handleChangeSearch = (message) => {
    setSearchKey(message);
    refetchById();
  };
  const handleDownload = async (id, index) => {
    const state = store.getState();
    // fetch(
    //   `${API_URL}/procurement/analytic-report`,

    //   {
    //     headers: {
    //       authorization: `Bearer ${state.auth.accessToken}`,
    //     },
    //   }
    // ).then((res) => {
    //   res.json().then((res) => {
    //       const fileURL = res.data?.url || "";
    //         let alink = document.createElement('a');
    //         alink.href = fileURL;
    //         alink.download = 'farmers.pdf';
    //         alink.click();
    //         window.open(fileURL, "_blank");
    //     })
    // }).catch((err) => {
    //   swal("No Data Found", {
    //     buttons: false,
    //     icon: "error",
    //     title: "Error",
    //     timer: 1500,
    //   });
    // })
    setShowLoadingOne(true);
    setLoaderIndex(index);
    let payload = {
      ProcCode: id,
      entity_type:
        RolesFromToken?.organization_type === "Manufacturers"
          ? "Buyer"
          : "Procurement Admin",
      user_id: RolesFromToken?.organization_id,
    };
    postSummary(payload)
      .unwrap()
      .then((data) => {
        const fileURL = data?.data?.url || "";
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "report.pdf";
        alink.target = "_blank";
        alink.click();
        setShowLoadingOne(false);
        setLoaderIndex("");
      })
      .catch((error) => {
        console.error("Error fetching the file URL:", error);
        setShowLoadingOne(false);
      });
  };

  const handleDownloadSummary = (id, index) => {
    let payload = {
      ProcCode: id,
      entity_type:
        RolesFromToken?.organization_type === "Manufacturers"
          ? "Buyer"
          : "Procurement Admin",
      user_id: RolesFromToken?.organization_id,
    };
    setLoaderIndex(index);
    setShowLoadingTwo(true);
    postReport(payload)
      .unwrap()
      .then((data) => {
        const fileURL = data?.data?.url || "";
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "summary.pdf";
        alink.target = "_blank";
        alink.click();
        setShowLoadingTwo(false);
        setLoaderIndex("");
      })
      .catch((error) => {
        console.error("Error fetching the file URL:", error);
        setShowLoadingTwo(false);
      });
  };

  return (
    <div>
      {/* {analyticsdata.length===0?<Pages404/>: */}
      <Row className="">
        <Col lg="12">
          <Card style={{ border: "1px solid #d1d1d1" }}>
            <CardHeader
              className="p-3 text-center text-black"
              style={{
                fontWeight: "600",
                color: "#000000de",
                backgroundColor: "#f0f0f0",
              }}
            >
              <h5>
                <img
                  src="https://cdn-icons-png.flaticon.com/128/893/893220.png"
                  height="20"
                  width="20"
                />{" "}
                &nbsp;Leading Suppliers
              </h5>
            </CardHeader>
            <CardBody className="p-3">
              <div className="border-0 rounded-3 p-0 p-lg-1">
                <div className="d-flex justify-content-between align-items-center ">
                  <div
                    className="text-center w-100 w-md-30 cursor-pointer"
                    onClick={() => handleDetails("trades")}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center mx-auto mb-2 p-3"
                      style={{
                        backgroundColor: "#dcfce7",

                        height: "60px",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <img
                        src="https://cdn4.iconfinder.com/data/icons/economic-crisis-20/512/31_Cash_Flow_Exchange_Trades_Business_and_Finance_Economic_Crises-256.png"
                        alt="Total Trades Icon"
                        className="img-fluid"
                        style={{ width: "30px", height: "30px" }}
                      />
                    </div>
                    <h6 className="mb-1">Total Trades</h6>
                    <h6 className="fw-bold text-primary">
                      {new Intl.NumberFormat("en-IN").format(
                        Tradesdata?.total_trades
                      )}
                      &nbsp;&nbsp;
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/13554/13554816.png"
                        width="30"
                      />
                    </h6>
                  </div>

                  <div
                    className="text-center w-100 w-md-30 mx-2 cursor-pointer"
                    onClick={() => handleDetails("qty")}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center mx-auto mb-2 p-3"
                      style={{
                        backgroundColor: "#fee2e2",

                        height: "60px",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <img
                        src="https://cdn2.iconfinder.com/data/icons/key-performance-indicators-2/512/Volume-amount-quantity-amount-ball-number-64.png"
                        alt="Middle Icon"
                        className="img-fluid"
                        style={{ width: "30px", height: "30px" }}
                      />
                    </div>
                    <h6 className="mb-1">Total Quantity</h6>
                    <h6 className="fw-bold text-primary">
                      {Tradesdata?.total_qty
                        ? new Intl.NumberFormat("en-IN").format(
                            Math.trunc(Tradesdata?.total_qty)
                          )
                        : ""}
                      &nbsp;&nbsp;
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/13554/13554816.png"
                        width="30"
                      />
                    </h6>
                  </div>

                  <div
                    className="text-center w-100 w-md-30 mx-2 cursor-pointer"
                    onClick={() => handleDetails("price")}
                  >
                    <div
                      className="d-flex justify-content-center align-items-center mx-auto mb-2 p-3"
                      style={{
                        backgroundColor: "#dcfce7",

                        height: "60px",
                        boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                      }}
                    >
                      <img
                        src="https://cdn0.iconfinder.com/data/icons/business-finance-v2-0/64/calculator-receipt-price-payment-256.png"
                        alt="Total Price Icon"
                        className="img-fluid"
                        style={{ width: "30px", height: "30px" }}
                      />
                    </div>
                    <h6 className="mb-1">Total Price</h6>
                    <h6 className="fw-bold text-primary">
                      ₹{" "}
                      {Tradesdata?.total_price
                        ? new Intl.NumberFormat("en-IN").format(
                            Math.trunc(Tradesdata?.total_price)
                          )
                        : ""}
                      &nbsp;&nbsp;
                      <img
                        src="https://cdn-icons-png.flaticon.com/128/13554/13554816.png"
                        width="30"
                      />
                    </h6>
                    {/* <h6 className="text-gray">
          Avg Price:
          {Tradesdata?.total_price && Tradesdata?.total_trades
            ? new Intl.NumberFormat("en-IN").format(
                Math.trunc(Tradesdata.total_price / Tradesdata.total_trades)
              )
            : ""}
        </h6> */}
                  </div>
                </div>
              </div>
              <TopTenChart data={topTraders} className="mt-3" />
            </CardBody>
          </Card>
        </Col>
        <Col className="col-lg-6">
          <Card style={{ border: "1px solid #d1d1d1" }}>
            <CardHeader
              className="p-3 text-center text-black"
              style={{
                fontWeight: "600",
                color: "#000000de",
                backgroundColor: "#f0f0f0",
              }}
            >
              <h5>
                <img
                  src="https://cdn-icons-png.flaticon.com/128/610/610128.png"
                  height="20"
                  width="20"
                />
                &nbsp;&nbsp;Location-wise Trades
              </h5>
            </CardHeader>
            <CardBody className="p-3">
              <TradesChart data={supplierList} />
            </CardBody>
          </Card>
        </Col>
        <Col lg="6">
          <Card style={{ border: "1px solid #d1d1d1" }}>
            <CardHeader
              className="p-3 text-center text-black"
              style={{
                fontWeight: "600",
                color: "#000000de",
                backgroundColor: "#f0f0f0",
              }}
            >
              <h5>
                <img
                  src="https://cdn-icons-png.flaticon.com/128/2244/2244228.png"
                  height="20"
                  width="20"
                />{" "}
                &nbsp;Month-wise Trades
              </h5>
            </CardHeader>
            <CardBody className="p-3">
              <AdminMonthChart data={Tradesdata} className="mt-3" />
            </CardBody>
          </Card>
        </Col>

        <Col lg="12">
          <Card style={{ border: "1px solid #d1d1d1" }}>
            <CardHeader
              className="p-3 text-center text-black"
              style={{
                fontWeight: "600",
                color: "#000000de",
                backgroundColor: "#f0f0f0",
              }}
            >
              <h5>
                <img
                  src="https://cdn-icons-png.flaticon.com/128/4258/4258187.png"
                  height="20"
                  width="20"
                />
                &nbsp;&nbsp;Trades{" "}
              </h5>
            </CardHeader>

            <CardBody className="p-3">
              <div className="row">
                {showLoading ? (
                  <Skeleton count={15} height="20px" />
                ) : supplierList?.length === 0 ? (
                  <NoData />
                ) : (
                  <>
                    {supplierList?.slice(0, 4).map((item, index) => (
                      <div
                        className="col-md-4 col-xl-3 mt-3"
                        style={{ cursor: "pointer" }}
                        onClick={() => handleIdData(item.name, item.name)}
                      >
                        <div
                          className={`cardSampleDashoard order-cardSample`}
                          style={{
                            border:
                              showcolouredBorder === item.name
                                ? "1px solid orange"
                                : "1px solid #fffdfd",
                            boxShadow:
                              showcolouredBorder === item.name
                                ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
                                : "",
                            backgroundColor: "#f9f9f9",
                          }}
                        >
                          <div className="card-blockSample">
                            <h6
                              className="m-b-20 text-center"
                              style={{ color: "#374151" }}
                            >
                              <Tooltip title="Supplier Name" placement="top">
                                {item.supplier_name}
                              </Tooltip>
                            </h6>
                            <div className="d-flex justify-content-between align-items-center">
                              <Tooltip title="Total Quantity">
                                <h6 className="text-right f300">
                                  <img
                                    src="https://cdn1.iconfinder.com/data/icons/ecommerce-61/48/eccomerce_-_shopping_cart-64.png"
                                    width="20"
                                    height="20"
                                  />
                                  <span className="mx-2 textGreyShade f300">
                                    {item.total_qty.toFixed(2)} MT
                                  </span>
                                </h6>
                              </Tooltip>
                              <Tooltip title="Total Price">
                                <span
                                  className={handleDynamicClass(index)}
                                  style={{ padding: "2px" }}
                                >
                                  <CurrencyRupeeIcon
                                    fontSize="small"
                                    className="f300"
                                  />
                                  {item.total_price}
                                </span>
                              </Tooltip>
                            </div>
                            <div className="d-flex justify-content-between align-items-center mt-1">
                              <span className="textGreyShade f300 mx-3">
                                Total Trades
                              </span>
                              <Tooltip title="Total Trades">
                                <span
                                  className={handleDynamicClassText(index)}
                                  style={{
                                    marginRight: "25px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {item.total_trades}
                                </span>
                              </Tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    {products.length > 4 ? (
                      <div className="d-flex justify-content-end">
                        {viewAll ? (
                          <Button
                            className="btn float-right"
                            onClick={() => setViewAll(false)}
                          >
                            View Less
                          </Button>
                        ) : (
                          <Button
                            className="btn float-right"
                            onClick={() => setViewAll(true)}
                          >
                            View All
                          </Button>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>

      {viewAll == true ? (
        <Row className="">
          <Col className="col-lg-12 ">
            <Card className="borderShade">
              <CardBody className="p-3 " style={{ backgroundColor: "#f3f4fc" }}>
                <div className="row mt-2">
                  {supplierList
                    ?.slice(6, supplierList?.length)
                    .map((item, index) => {
                      return (
                        <>
                          <div
                            className="col-md-4 col-xl-3 mt-2 "
                            style={{ cursor: "pointer" }}
                            onClick={() => handleIdData(item.name, item.name)}
                          >
                            <div
                              className={`cardSample  order-cardSample`}
                              style={{
                                border:
                                  showcolouredBorder === item.name
                                    ? "1px solid orange"
                                    : "1px solid #fffdfd",
                                boxShadow:
                                  showcolouredBorder === item.name
                                    ? "rgba(0, 0, 0, 0.24) 0px 3px 8px"
                                    : "",
                                backgroundColor: "white",
                              }}
                            >
                              <div className="card-blockSample">
                                <h6
                                  className="m-b-20 text-center"
                                  style={{ color: "#374151" }}
                                >
                                  <Tooltip
                                    title="Supplier Name"
                                    placement="top"
                                  >
                                    {item.supplier_name}
                                  </Tooltip>

                                  {/* <span
                                className="mdi mdi-arrow-top-right bg-c-blue-textColor"
                                style={{ float: "right" }}
                              >
                              </span> */}

                                  <br />
                                </h6>
                                <div className="d-flex justify-content-between align-items-center">
                                  <Tooltip title="Total Quantity">
                                    <h6 className="text-right f300">
                                      <ProductionQuantityLimitsIcon
                                        fontSize="small"
                                        className={handleDynamicClassText(
                                          index
                                        )}
                                      />
                                      <span className="mx-2 textGreyShade f300">
                                        {item.total_qty.toFixed(2)} MT
                                      </span>
                                    </h6>
                                  </Tooltip>
                                  <Tooltip title="Total Price">
                                    <span
                                      className={handleDynamicClass(index)}
                                      style={{ padding: "2px" }}
                                    >
                                      <CurrencyRupeeIcon
                                        fontSize="small"
                                        className="f300"
                                      />
                                      {item.total_price}
                                    </span>
                                  </Tooltip>
                                </div>

                                <div className="d-flex justify-content-between align-items-center mt-1">
                                  <span className="textGreyShade f300 mx-3">
                                    {" "}
                                    Total Trades
                                  </span>
                                  <Tooltip title="Total Trades">
                                    <span
                                      className={handleDynamicClassText(index)}
                                      style={{
                                        marginRight: "25px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {" "}
                                      {item.total_trades}
                                    </span>
                                  </Tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      );
                    })}
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : (
        ""
      )}

      <Modal show={show} onHide={handleClose} size="xl">
        <Modal.Header closeButton>
          <Modal.Title style={{ width: "100%" }}>
            {showIdLoading ? (
              "Details"
            ) : (
              <div className="fw-bold f400 d-flex justify-content-between mt-2">
                <div>
                  Supplier :{" "}
                  <span className="steelblue">
                    {supplierIdData?.supplier_name}
                  </span>
                </div>
                <div>
                  {" "}
                  Address :{" "}
                  <span className="steelblue">
                    {supplierIdData?.supplier_address}
                  </span>
                </div>
              </div>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="bg-secondary3"
          style={{ padding: "1rem 1.5rem" }}
        >
          {showIdLoading ? (
            <Skeleton count={15} height="20px" />
          ) : (
            <div class="row mt-2">
              {/* <CustomSearchBar sendSearchFunction={handleChangeSearch}/> */}
              {supplierIdData?.trades?.map((item, index) => {
                return (
                  <Card>
                    <div className=" mt-2 d-flex justify-content-between align-items-center">
                      <div className="indexStyle">
                        <div>{index + 1}</div>
                      </div>
                      <div>
                        <>
                          <Button
                            className="buttonOrangeDefaultColor mt-3  mb-2"
                            size="sm"
                            onClick={() =>
                              handleDownload(item.procurement_id, index)
                            }
                          >
                            Trade Report <i class="mdi mdi-download"></i>{" "}
                            {index === loaderIndex && loadingone ? (
                              <Spinner size="sm" />
                            ) : (
                              ""
                            )}
                          </Button>
                          <Button
                            className="buttonOrangeDefaultColor2 mt-3  mb-2"
                            size="sm"
                            onClick={() =>
                              handleDownloadSummary(item.procurement_id, index)
                            }
                          >
                            Summary Report <i class="mdi mdi-download"></i>
                            {index === loaderIndex && loadingtwo ? (
                              <Spinner size="sm" />
                            ) : (
                              ""
                            )}
                          </Button>
                        </>
                      </div>
                    </div>
                    <CardBody style={{ padding: "1rem 1.5rem" }}>
                      <div className="fw-bold f300 d-flex justify-content-between">
                        <div className="">
                          {" "}
                          Billing Address :{" "}
                          <span class="steelblue f300">{item.billing}</span>
                        </div>
                        <div className="">
                          {" "}
                          Shipping Address :{" "}
                          <span class="steelblue f300">{item.shipping}</span>
                        </div>
                      </div>
                      <div className="fw-bold f300 d-flex justify-content-between mt-2">
                        <div className="">
                          {" "}
                          Trade Creation Date :{" "}
                          <span class="steelblue f300">
                            {item.trade_created_date.slice(0, 10)}
                          </span>
                        </div>
                        <div className="">
                          {" "}
                          Trade Completion Date :{" "}
                          <span class="steelblue f300">
                            {item.trade_completed_date.slice(0, 10)}
                          </span>
                        </div>
                      </div>

                      <div className="fw-bold f300 d-flex justify-content-between mt-2">
                        <div className="">
                          {" "}
                          Total Qty :{" "}
                          <span class="steelblue f300">
                            {item.total_qty}{" "}
                            {item?.invoices?.every((inv) =>
                              inv.items.every(
                                (d) => d.uom === item.invoices[0].items[0]?.uom
                              )
                            )
                              ? item.invoices[0].items[0]?.uom
                              : ""}
                          </span>
                        </div>
                        <div className="">
                          {" "}
                          Total Price:
                          <CurrencyRupeeIcon className="f300" />{" "}
                          <span class="steelblue f300">
                            {item.total_amount}
                          </span>
                        </div>
                      </div>
                      <Table striped hover className="mt-2">
                        <thead>
                          <tr>
                            <th className="th-sm">Item Name</th>
                            <th className="th-sm">Item Code</th>
                            <th className="th-sm">Quantity</th>
                            <th className="th-sm">
                              Rate (<CurrencyRupeeIcon className="f300" />)
                            </th>
                            <th className="th-sm">
                              Amount (<CurrencyRupeeIcon className="f300" />)
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {item?.invoices?.map((dataParent, index) => {
                            return dataParent?.items.map((data) => {
                              return (
                                <tr key={index} className="mt-3">
                                  <td>{data.item_name}</td>
                                  <td>{data.item_code}</td>
                                  <td>
                                    {data.qty} {data.uom}
                                  </td>
                                  <td>{data.rate}</td>
                                  <td>{data.amount}</td>
                                </tr>
                              );
                            });
                          })}
                        </tbody>
                      </Table>
                    </CardBody>
                  </Card>
                );
              })}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showDetails} onHide={handleCloseDetails}>
        <Modal.Header closeButton>
          <Modal.Title>
            {ListName === "trades"
              ? "Trades Details"
              : ListName === "qty"
              ? "Quantity Details"
              : "Price Details"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "1rem 1.5rem" }}>
          <div class="row mt-2 backgroundColorBeigeHealth">
            <Table striped hover className="mt-2">
              <thead>
                <tr>
                  <th className="th-sm">Commodity</th>
                  {ListName === "price" && (
                    <>
                      <th className="th-sm">Min Price</th>
                      <th className="th-sm">Avg Price</th>
                    </>
                  )}
                  <th className="th-sm">
                    {ListName === "trades"
                      ? "Trades"
                      : ListName === "qty"
                      ? "Quantity"
                      : "Max Price"}
                  </th>
                </tr>
              </thead>
              {Object.keys(Tradesdata?.commodities || {}).length !== 0 ? (
                <tbody>
                  {Object.entries(Tradesdata?.commodities).map(
                    ([item, details]) => (
                      <tr key={item}>
                        <td>{item}</td>
                        {ListName === "price" && (
                          <>
                            <td className="th-sm">{details.min_price}</td>
                            <td className="th-sm">{details.avg_price}</td>
                          </>
                        )}
                        <td>
                          {ListName === "trades"
                            ? details.total_trades
                            : ListName === "qty"
                            ? details.total_qty
                            : details.max_price}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              ) : (
                ""
              )}
            </Table>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDetails}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SampleDashboard;
